<div class="container-fluid">
  <div #notificationContainer></div>
  <div kendoDialogContainer></div>
  <div class="k-flex-layout k-justify-content-between k-align-items-center">
    <h2>Markdowns</h2>
    <div class="k-p-4">
      <button kendoButton themeColor="primary" [svgIcon]="plusIcon" (click)="createHandler()">Create new</button>
    </div>
  </div>

  <kendo-grid
    [data]="gridView"
    [pageable]="{ pageSizes: [5, 10, 20] }"
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [sort]="gridState.sort"
    [sortable]="true"
    (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="itemName" title="Name" [width]="180"></kendo-grid-column>
    <kendo-grid-column field="usage" title="Usage" [width]="180"></kendo-grid-column>
    <kendo-grid-column field="createdAt" title="Created At" [width]="180" format="d/MM/yyyy HH:mm">
    </kendo-grid-column>
    <kendo-grid-column field="updatedAt" title="Updated At" [width]="180" format="d/MM/yyyy HH:mm">
    </kendo-grid-column>
    <kendo-grid-column field="latestMdVersionId" title="Current Version" [width]="120" [sortable]="false">
    </kendo-grid-column>
    <kendo-grid-column field="enabled" title="Status" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [checked]="dataItem.enabled" (valueChange)="changeStatus(dataItem, $event)"></kendo-switch>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Actions" [width]="200" [sortable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-buttongroup>
          <button kendoButton themeColor="primary" (click)="editHandler(dataItem)" [svgIcon]="editIcon">Edit</button>
          <button kendoButton themeColor="error" (click)="deleteHandler(dataItem)" [svgIcon]="cancelIcon">Delete</button>
        </kendo-buttongroup>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  @if (isEditorVisible) {
    <form [formGroup]="editorForm" class="k-gap-8 k-mt-4">
      <h2>{{ editorStatus === EditorStatus.updating ? 'Markdown Editor' : 'Create Markdown' }}</h2>
      <div class="k-p-4 bg-white">
        <kendo-label [text]="'Filename'">
          <kendo-textbox [formControlName]="'filename'"/>
        </kendo-label>
      </div>
      <kendo-toolbar class="k-mb-4">
        @if (editorStatus === EditorStatus.updating) {
          <kendo-toolbar-dropdownbutton
            [text]="'▼ Version: ' + (editorForm.get('selectedVersion')?.value?.id)"
            [data]="availableVersions"
            textField="id"
            (itemClick)="onVersionChange($event)"
            [disabled]="(availableVersions?.length || 0) < 2"
            style="width: 150px"
          />
        }
        <kendo-toolbar-spacer/>
        <kendo-toolbar-button
          text="Copy"
          (click)="copyContent()"
          [svgIcon]="copyIcon"/>
        <kendo-toolbar-button
          text="Save"
          themeColor="primary"
          [disabled]="isEditorReadonly"
          (click)="saveHandler()"
          [svgIcon]="saveIcon"/>
      </kendo-toolbar>
      <md-editor [formControlName]="'content'" [height]="'800px'" [required]="true"/>
    </form>
  }
</div>
